import React from 'react';

export type FechaProps = {
    readonly fecha: string;
};

const fechaRegEx = /^(\d{4})-(\d{2})-(\d{2})T?/;

export class Fecha extends React.PureComponent<FechaProps> {
    public render() {
        const { fecha } = this.props;

        const result = fechaRegEx.exec(fecha);
        if (!result) return '<fecha inválida>';

        const [, año, mes, dia] = result;

        return (
            <>
                {dia}-{mes}-{año}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/componentes/Fecha/index.tsx